/* tslint:disable */
/* eslint-disable */
/**
 * Apperta Physical Health REST API
 * Apperta Physical Health REST API
 *
 * The version of the OpenAPI document: 0.2.0-SNAPSHOT2
 * Contact: info@staircase13.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Represents an audit entry
 * @export
 * @interface ExternalAuditDto
 */
export interface ExternalAuditDto {
    /**
     * Type
     * @type {string}
     * @memberof ExternalAuditDto
     */
    type: string;
    /**
     * Action
     * @type {string}
     * @memberof ExternalAuditDto
     */
    action: string;
    /**
     * Attributes
     * @type {{ [key: string]: string; }}
     * @memberof ExternalAuditDto
     */
    attributes: { [key: string]: string; };
}

/**
 * Check if a given object implements the ExternalAuditDto interface.
 */
export function instanceOfExternalAuditDto(value: object): value is ExternalAuditDto {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('action' in value) || value['action'] === undefined) return false;
    if (!('attributes' in value) || value['attributes'] === undefined) return false;
    return true;
}

export function ExternalAuditDtoFromJSON(json: any): ExternalAuditDto {
    return ExternalAuditDtoFromJSONTyped(json, false);
}

export function ExternalAuditDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalAuditDto {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'action': json['action'],
        'attributes': json['attributes'],
    };
}

export function ExternalAuditDtoToJSON(value?: ExternalAuditDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'type': value['type'],
        'action': value['action'],
        'attributes': value['attributes'],
    };
}

